import React, { useContext, Fragment } from 'react';
import { SurveyContext } from '../context/surveyContext';

export default function UserInfo({ exportPdf }) {
  const { result, survey } = useContext(SurveyContext);
  return (
    <Fragment>
      {survey && (
        <div className='result-top-section__user-info'>
          <div className='icon-wrapper'>
            <div className='icons' onClick={exportPdf}>
              <span>Spara som PDF </span>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
              >
                <path
                  fill='#131313'
                  d='M19,12 L19,19 L5,19 L5,12 L3,12 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,12 L19,12 Z M13,12.67 L15.59,10.09 L17,11.5 L12,16.5 L7,11.5 L8.41,10.09 L11,12.67 L11,3 L13,3 L13,12.67 Z'
                  transform='translate(-3 -3)'
                />
              </svg>
            </div>
            <div className='icons' onClick={() => window.print()}>
              <span>Skriv ut sidan </span>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='18'
                viewBox='0 0 20 18'
              >
                <path
                  fill='#131313'
                  d='M19,9 L5,9 C3.34,9 2,10.34 2,12 L2,18 L6,18 L6,22 L18,22 L18,18 L22,18 L22,12 C22,10.34 20.66,9 19,9 Z M16,20 L8,20 L8,15 L16,15 L16,20 Z M19,13 C18.45,13 18,12.55 18,12 C18,11.45 18.45,11 19,11 C19.55,11 20,11.45 20,12 C20,12.55 19.55,13 19,13 Z M18,4 L6,4 L6,8 L18,8 L18,4 Z'
                  transform='translate(-2 -4)'
                />
              </svg>
            </div>
          </div>
          <h2>{result.name}</h2>
          <div className='result-top-section__user-info-text'>
            <div>
              <p className='user-text__bold'>
                {survey.survey_label_description_1}
              </p>
              <p>{result.description1}</p>
            </div>
            <div>
              <p className='user-text__bold'>
                {survey.survey_label_description_2}
              </p>
              <p>{result.description2}</p>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
